import { googleMapsKey, Colors } from '@capcenter/shared';
import HouseMissingImage from './img/single-family.svg';

function GoogleStaticMapSrc(p: any, width?: number, height?: number, scale?: 1 | 2) {
	if (!p.Latitude || !p.Longitude)
		return HouseMissingImage;
	const latlng = p.Latitude + ',' + p.Longitude;

	const url =
		'https://maps.googleapis.com/maps/api/staticmap?size=' +
		(width ? width : 400) +
		'x' +
		(height ? height : 300) +
		'&scale=' +
		(scale ? scale : 1) +
		'&zoom=16&center=' +
		latlng +
		'&markers=color:' +
		Colors.orange500.replace('#', '0x') +
		'%7C' +
		latlng +
		'&key=' +
		googleMapsKey;

	return HouseMissingImage;
}

export default GoogleStaticMapSrc;
